export default {
  mnj: {
    slogan: 'You are important, it all starts with that...',
    description: 'Platform for contact recruitment <br /> and job search',
  },
  roles: {
    candidate: 'Job seekers',
    employer: 'Employer',
    recruitmentAgency: 'Recruitment agency',
    admin: 'Administrator',
    guest: 'Guest',
    user: 'User',
    participant: 'Participant',
  },
  system: {
    videoResume: 'Video CV',
    videoVacancy: 'Video vacancy',
    videoReview: 'Video interview',
    videoBusinessCard: 'Video business card',
    videoConversation: 'Video conversation',
  },
  landingPage: {
    partnersSection: {
      intro: 'we are trusted',
      title: 'Our clients',
    },
    videoMaterials: {
      intro: 'sometimes examples inspire',
      title: 'Video materials',
      video1: 'Video CV autonomous recording',
      video2: 'Video CV recording with support of our platform assistant',
      video3: 'Video Interview recording example',
      video4: 'Video vacancy autonomous recording',
      video5: 'Video vacancy recording with support of our platform assistant',
      video6: 'Video business card recording',
    },
    tariffs: {
      title: 'Services and rates',
      slogan: 'It is pleasant to make the right choice',
      showAsTable: 'Show as table',
      showAsTiles: 'Show as tiles',
    },
    reviews: {
      title: 'Our customer reviews',
      slogan: 'What they say about us',
      text: 'We strive to be useful to our users and carefully monitor feedback',
    },
    partners: {
      title: 'Our customers',
      slogan: 'We are trusted',
    },
    joinUs: {
      title: 'Stay informed of our updates and improvements.',
      text: 'We are constantly evolving and keep being as useful as possible to our users. Let us know your email if you want to be the first to know about platform’s updates and improvements.',
    },
  },
  aboutPlatformModalForm: {
    notifyTitle: 'Are you interested?',
    notifyText: 'Do you want to know more about My new job® platform? Enter your contact details and we will call or write back shortly.',
    notifyBtn: 'Enter contact details',
    modalTitle: 'Learn about the capabilities of My new job® platform',
    modalText: 'Do you want to know more about the contact recruitment platform? Enter your contact details and we will call or write back shortly.',
  },
  menuLinks: {
    howItWork: 'How does it work?',
    aboutCompany: 'About company',
    news: 'News',
    youCandidate: 'For job seekers',
    youEmployer: 'For employers',
    youAgency: 'For recruitment agencies',
    policy: 'Data processing policy',
    documents: 'Legal documents',
    softwareRequirements: 'Software requirements',
    tariffs: 'Our services and rates',
    contacts: 'Contacts',
    support: 'Technical Support',
    terms: 'Terms of Service',
    safeMnj: 'Safe My new job ®',
  },
  periods: {
    oneMonth: 'month',
    threeMonth: 'three months',
    sixMonth: 'six months',
    twelveMonth: 'year',
  },
  plans: {
    accessPlans: 'Access tariffs',
    servicesPlans: 'Service tariffs',
    details: 'Details',
    addToCart: 'Add to cart',
    popular: 'Popular',
    rubMonth: 'rubles/month',
    rub: 'rubles',
    from: 'from',
    discountText: 'Discount over',
    totalSaving: 'Total savings are',
    rubPerMonth: 'rubles per month ',
    currentPlan: 'Your current service plan ',
    forCandidates: 'For job seekers',
    forEmployers: 'For employers',
    forAgency: 'For recruitment agencies',
    planType1: 'Unlimited access to online video sessions conducting',
    planType2: 'Unlimited access to online video sessions recording ',
    planType3: 'Неограниченый доступ к записи видеоопросов',
    planType4: 'Неограниченый доступ к базе данных резюме',
    planType5: 'Доступ к возможности публикации вакансий',
    planType6: 'Объём хранилища для записи онлайн-видеосессий',
    planSubscribe: 'Subscribe to receive updates!',
    updatesInform: 'Inform me about updates ',
    subscribeTitle: 'Subscribe to our newsletter',
    subscribeText: 'Subscribe to our newsletter and stay informed of all our updates. Be first to receive '
      + 'our best offers!',
    subscribe: 'Subscribe',
    freeCandidate: {
      title: 'Free',
      descr: 'Unlimited access <br /> to online video sessions without recording',
      includeText: 'Unlimited access to online video sessions <b> conducting </b>',
      includeText2: 'Unlimited access to online video sessions <b> recording </b>',
      includeText3: 'Video CV autonomous <b> recording </b>',
    },
    baseCandidate: {
      title: 'Base',
      descr: 'Access to online video sessions with recording',
      includeText: 'Unlimited access to online video sessions <b> conducting </b>',
      includeText2: 'Unlimited access to online video sessions <b> recording </b>',
      includeText3: 'Video CV autonomous <b> recording </b>',
    },
    free: {
      title: 'Free',
      descr: 'Unlimited access <br /> to online video sessions without recording',
      includeText: 'Unlimited access to online video sessions <b> conducting </b>',
      includeText2: 'Unlimited access to online video sessions <b> recording </b>',
      includeText3: 'Video vacancies autonomous <b> recording </b>',
    },
    base: {
      title: 'Base',
      descr: 'Access to online video sessions with recording',
      includeText: 'Unlimited access to online video sessions <b> conducting </b>',
      includeText2: 'Unlimited access to online video sessions <b> recording </b>',
      includeText3: 'Video vacancies autonomous <b> recording </b>',
    },
    all: {
      title: 'All inclusive',
      descr: 'Access to video sessions, video questionnaire with recording and to CV data base and job '
        + 'openings posting',
      includeText: 'Unlimited access to video sessions <b> conducting </b> and <b> recording </b>',
      includeText2: 'Unlimited access to conducting <b> video questionnaire </b> of candidates',
      includeText3: 'Unlimited access to <b> CV </b> data base and <b> job openings </b> posting',
    },
    video_resume: {
      title: 'Video cv recording',
      descr: 'Video CV recording <br /> with a platform assistance',
      includeText: 'Service for video <b> CV recording </b> with a platform assistance',
      includeText2: 'One-time service at the stated price',
      includeText3: 'The date and time of <b> video CV </b> conducting is set by you',
    },
    videos_question: {
      title: 'Video questionnaire recording',
      descr: 'Access to video sessions <br /> and video questionnaire with recording',
      includeText: 'Unlimited access to video sessions <b> conducting </b> and <b> recording </b>',
      includeText2: 'Video vacancies autonomous <b> recording </b>',
      includeText3: 'Unlimited access to conducting <b> video questionnaire </b> of candidates',
      includeText4: 'page',
    },
    videos_vacancy: {
      title: 'Video vacancy recording',
      descr: 'Video vacancy recording with a platform assistance',
      includeText: 'Service for <b> video vacancy recording </b> with a platform assistance',
      includeText2: 'One-time service at the stated price',
      includeText3: 'The date and time of <b> video vacancy </b> conducting is set by you',
    },
    staff_recruitment: {
      title: 'Staff recruitment',
      descr: 'The price is indicated for one employee',
      includeText: 'Candidates for specific vacancy are selected with <b> video CVs </b>',
      includeText2: 'Staff selection for the position is proceeded until it is filled',
      includeText3: 'Price for an employee selection is average, detailed conditions are set forth at ',
      includeText4: 'page',
    },
    candidates_flow: {
      title: 'Candidates flow',
      descr: 'Up to 10 candidates a month for 1 vacancy',
      includeText: 'Candidates for specific vacancy are selected with <b> video CVs </b>',
      includeText2: 'Maximum <b> 10 candidates </b> a month for 1 vacanc',
      includeText3: 'f the right candidate is not found you can <b> prolong </b> the service',
    },
  },
  inputs: {
    email: 'Your email address',
    name: 'Name',
    surname: 'Surname',
    patronymic: 'Patronymic',
    companyName: 'Company name',
    email2: 'E-mail address',
    phoneNumber: 'Phone number ',
    phone: 'Phone',
    companyName2: 'Company',
    person: 'Contact person',
    companyType: 'Type of company',
    website: 'Website',
    employeesCount: 'Select the number of employees',
    city: 'Address',
    next: 'Next',
  },
  placeholders: {
    role: 'Select role',
    comment: 'Type your comment',
    name: 'Enter your name',
    surname: 'Enter your surname',
    enterMiddleName: 'Enter middle name',
    companyName: 'Enter your company name',
    email: 'Enter your e-mail address',
    phoneNumber: 'Enter your phone number',
    enterName: 'Enter username',
    placeholderStartDate: 'Start date',
    placeholderEndDate: 'Final date',
    fullName: 'Enter name',
  },
  buttons: {
    logIn: 'Log in',
    register: 'Registration',
    watchVideo: 'Watch the video',
    startVideoCall: 'Start video call',
    startTrial: 'Start trial',
    details: 'Details',
    saving: 'Saving',
    tryFree: 'Try free',
    save: 'Save',
    toMainPage: 'To main page',
    clear: 'Clear',
    ok: 'Ok',
    confirm: 'Confirm',
    watchExample: 'See example',
    howItWork: 'How does it work?',
    finish: 'Finish',
    cancel: 'Cancel',
    sent: 'Sent',
    close: 'Close',
    subscribe: 'Subscribe',
    submit: 'Submit',
    dispatch: 'Dispatch',
    logOut: 'Log out',
  },
  validation: {
    isRequired: 'Is required',
    notValidEmail: 'Invalid email format',
    maxNumberSize: 'Max number length %t% symbols',
    minNumberSize: 'Min number length %t% symbols',
    maxEmailSize: 'Max email length %t% symbols',
    maxNameSize: 'Max name length %t% symbols',
    maxLastNameSize: 'Max surname length %t% symbols',
    maxMiddleNameSize: 'Max middle name length %t% symbols',
  },
  delimeter: {
    or: 'or',
  },
  footer: {
    company: 'Mynewjob LLC',
    downloadPresentation: 'Download presentation',
    contacts: 'Contacts',
    techSupport: 'Technical support',
    conditions: 'Terms and Conditions',
    safeMnj: 'Safe My New job®',
    requirements: 'Software requirements',
    documents: 'Legal documents',
    policy: 'Data processing policy',
    presentRu: 'Download presentation (RU)',
    presentEn: 'Download presentation (ENG)',
    watchPresentation: 'Video presentation',
    skolkovo: 'Resident',
  },
  onlinePoll: {
    notifyTitle: 'Do you want to get free and expanded access to My new job® platform services?',
    notifyText: 'Take the online questionnaire. It will take you no longer than 10 minutes. Help us to become more useful!',
    notifyBtn: 'Take an online questionnaire',
    startTitle: 'We are glad to welcome you on the online questionnaire page of My new job® platform',
    about: {
      title1: 'My new job® platform',
      text1: 'This is an innovative online platform for contacting recruitment and job search',
      title2: 'Help us to become more useful to you',
      text2: 'Guide us to develop only those platform functional capabilities that will be really useful to you.',
      title3: 'Answer the online questionnaire',
      text3: 'It will take maximum 10 minutes to answer 10 questions',
      title4: 'Receive a gift from us',
      text4: 'Receive a promo code to activate free extended access to all basic services of My new job® platform '
        + 'right after answering the online questionnaire',
      title5: 'Use your gift',
      text5: 'Register on My new job® platform to use free and expanded access </br> After access activating, '
        + 'you will be granted <mark>from 30 to 120 free hours of video recording</mark> under the selected rate '
        + 'type for <mark>7 calendar days period</mark>',
      text6: 'Enter your e-mail address - a promo code will be sent to it after the online questionnaire full completing',
    },
    startOnlinePoll: 'Start online questionnaire',
    inputRole: 'Select user role',
    rateTitle: 'Rate the question on a scale of 1 to 10',
    nextQuestion: 'Next question',
    rateDescription: {
      title: 'The value of the points of the scale',
      negative: 'Conditionally negative evaluation',
      neutral: 'Conditionally neutral evaluation',
      positive: 'Conditionally positive evaluation',
    },
    finishTitle: 'Thank you,</br>you helped us to become more useful!',
    promoByMail: 'The promocode was successfully sent to you mail.',
    finishText1: 'From this moment you are the holder of promo code for free extended access to the functionality of the My new job® platform at the Basic rate with the ability to record video materials up to <mark>30 free hours</mark> for <mark>7 days</mark>',
    finishText2: 'Register on the platform to use your promo code',
    promoCodeLabel: 'Your promo code',
    terminate: 'Activate prior to',
    finishButton: 'Finish online questionnaire',
    notAvailableTitle: 'Online questionnaire is not available',
    notAvailableText: 'Online questionnaire is available only to unauthorized users.<br /> To answer, please log out of your profile',
    notEndedTitle: 'Online questionnaire is not completed',
    notEndedText: 'You have not answered all the questions of online questionnaire. Still finish the online questionnaire?',
  },
  units: {
    rublesPerMonth: 'rubles per month',
    rublesMonth: 'rubles/month',
    rubles: 'rubles',
    month: 'month',
    months: 'months',
    threeMonths: 'three months',
    halfYear: 'half a year',
    year: 'year',
    hours: 'hours',
    days: 'days',
    sec: 'sec',
    min: 'minutes',
    seconds: 'seconds',
    minS: 'min',
  },
  tariffs: {
    promoTariff: 'Promo rate',
    freeDemoAccess: 'Free trial access',
    accessTariff: 'Access rate',
    serviceTariff: 'Service rate',
    accessRates: 'Access rates',
    servicesRates: 'Services rates',
    totalDiscount: 'Total savings are',
    discount: 'Discount',
    moreThan: 'more than',
    choosePeriod: 'Choose a period:',
    totalHours: 'Total in-rate hours of recording',
    tariffCost: 'Rate cost:',
    accessPeriod: 'Demo access period',
    details: 'Read on',
    aboutRates: 'About rate',
    popular: 'Popular',
    individual: 'Individual calculation',
    contactUs: 'Contact us',
    addToCart: 'Rate successfully added to cart',
  },
  modalIndividualTariff: {
    title: 'Individual calculation',
    text: 'Individual rate is a special platform offer allowing to extend Standard rates properties upon request. Upon receiving and processing your request, the platform administration will provide a commercial proposal and an invoice for payment. After payment, a promotional code will be provided to activate your Individual rate.',
    tariffLabel: 'Select Standard rate which properties you wish to change',
    optionsLabel: 'Standard rate default properties',
    periodLabel: 'Individual rate validity period',
    countLabel: 'Number of activations / Users',
    nameLabel: 'Full name',
    namePlaceholder: 'Enter your name',
    phoneLabel: 'Phone number',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter your e-mail address',
    descriptionLabel: 'Describe your expectations of Individual rate',
    requisites: 'Attach your bank details',
    recordingHours: 'hours of recording',
    or: 'or',
    mB: 'megabytes of recording',
    days: 'calendar days',
    selectTariff: 'Select rate',
  },
  nav: {
    main: 'Main',
    feed: 'General feed',
    logIn: 'Log in',
    reg: 'Registration',
    startVideosession: 'Start video session',
    findVacancy: 'Find job opening',
    findCv: 'Find CV',
    myVideosessions: 'My video sessions',
    recordVideoVacancy: 'Video vacancies recording',
    recordVideoCv: 'Video CV recording',
    myVideovacancies: 'My video vacancies',
    videoBusinessCardRecording: 'Video business cards recording',
    myVideoBusinessCard: 'My video business card',
    myVideoSurveys: 'My video surveys',
    contacts: 'Contacts',
    feedback: 'Feedback',
    notifications: 'Notifications',
    vacancies: 'Vacancies',
    closeVacancy: 'Fill a vacancy',
    favoriteCv: 'Favorite CVs',
    myVideoCv: 'My video CVs',
    responsesAndInvitations: 'Responses and Invitations',
    chats: 'Chats',
    help: 'Help',
    mail: 'Mail',
    calendar: 'Calendar',
    requestForRecording: 'Requests for recording',
    logOut: 'Logout',
    resume: 'Resume',
    favoriteVacancies: 'Favorite vacancies',
    myPortfolio: 'My portfolio',
    controlPanel: 'Control panel',
    adminPanel: 'Admin panel',
    statistic: 'Statistic',
    dbHistory: 'Database - history',
    jobManagement: 'Job management',

    howItWork: 'How does it work?',
    aboutCompany: 'About Us',
    services: 'Our Services and Rates',
    forJobSeekers: 'For Job Seekers',
    forEmployers: 'For Employers',
    forAgency: 'For Recruitment Agencies',
    news: 'News',
    myAccount: 'My account',
    cart: 'Shopping cart',
    flow: 'Stream requests',
    selection: 'Selection requests',

    freeOnlineVideosession: 'Free online video sessions',
    videoInterviewRecord: 'Video interview recording',
    videoVacancyRecord: 'Video vacancies recording',
    videoResumeRecord: 'Video CV recording',
    linkPlacement: 'Link placement',
    videoPollRecord: 'Video questionnaire recording',
    portfolio: 'Portfolio',
    resumeAndMails: 'Resume',
    vacanciesBd: 'Vacancies',
    searchWork: 'Job application and job search',
    vacanciesAndVideoBusinessCard: 'Your vacancies and video visits',
    resumeBd: 'Resume database',
    inviteVideoInterview: 'Interview invitations and employee search',
    candidatesFlow: 'Candidates flow',
    privatePage: 'Your personal page on the platform',
    downloadPresentationRu: 'Download presentation (ru)',
    downloadPresentationEn: 'Download presentation (eng)',
    tariffs: 'Our services and rates',
    technicalSupport: 'Technical support',
    servicesTerms: 'Terms of service',
    safeMnj: 'Safe My new job ®',
    softwareRequirements: 'Software requirements',
    documents: 'Legal documents',
    dataTerms: 'Data processing policy',
    emptyCart: 'Your cart is empty',
    servicesCart: 'Services in cart',
    cabinet: 'Personal area',
    skolkovo: 'Resident',
    rights: 'All rights reserved',
    mnj: 'My new job® company',
  },
  registration: {
    remember: 'Remember',
    dontHaveAccount: "Don't have an account?",
    restorePassword: 'Restore password',
    enter: 'Enter',
    signIn: 'Sign in',
    enterPassword: 'Enter password',
    enterEmail: 'Enter email',
    snLogin: 'Log in using social networks',
    reg: 'Registration',
    forJobSeekers: 'For job seekers',
    jsText: 'For a successful job search, click "Register", fill in the appropriate fields of the form or use the quick registration via social networks',
    forEmployers: 'For employers',
    empText: 'To successfully search for worthy candidates, click "Register", fill in the appropriate fields of the form in two stages',
    forAgency: 'For recruitment agencies',
    agencyText: 'To successfully search for worthy candidates, click "Register", fill in the appropriate fields of the form in two stages',
    sReg: 'Service registration',

    completeReg: 'Complete registration',
    processing1: 'I consent to the',
    processing2: 'processing of personal data',
    quickReg: 'Quick registration via social networks',
  },
  feed: {
    filter: 'Filter',
    allPosts: 'All news',
    myLikes: 'I liked',
    myComments: 'Your comments',
    hotV: 'Hot vacancies',
    pl: 'The connecting recruitment platform',
    copy: 'Copy link',
    showMore: 'Show more …',
    hide: 'Hide …',
    liked: 'Liked',
    comments: 'Comments',
    comment: 'Comment',
    like: 'Like',
    hideComments: 'Hide comments',
    answer: 'Answer',
    remove: 'Remove',
    writeComment: 'Write a comment',
    firstLike: 'Be the first to like it',
    firstComment: 'Be the first to comment on this',
    showAnswers: 'Show answers',
    hideAnswers: 'Hide answers',
    noPosts: 'Posts not found',
    noVacancies: 'There is no vacancies',
  },
  time: {
    now: 'now',
    lessHour: 'less than an hour ago',
    hourAgo: 'hour ago',
    hoursAgo: 'hours ago',
    hoursAgo2: 'hours ago',
    today: 'Today',
  },
  contacts: {
    userList: 'My new job users list',
    recently: 'Recent',
    contacts: 'Contacts',
    add: 'Add to contacts',
    invite: 'Invite',
    social: 'Social network links',
  },
  common: {
    characters: 'characters',
    question: 'questions',
    question1: 'question',
    questions: 'questions',
    loading: 'Loading...',
    inviteSuccess: 'The invitation is sent',
    to: 'to',
    sentByEmail: 'Send by e-mail',
    openContacts: 'Open contacts',
    selectTariff: 'Choose a tariff',
    save: 'Save',
    saveAs: 'Save as',
    saving: 'Saving...',
    cancel: 'Cancel',
    up: 'Up',
    down: 'Down',
    remove: 'Remove',
    notFound: 'Not found',
    send: 'Send',
    sendAs: 'Send as',
    sentToParticipants: 'Sent to participants',
    sendToParticipants: 'Send to participants',
    sending: 'Sending',
    add: 'Add',
    listIsEmpty: 'List is empty',
    edit: 'Edit',
    saveAndHide: 'Save and hide',
    close: 'Close',
    exitText: 'Do you really want to log out?',
    saveAndSent: 'Save and Sent',
    copyLink: 'Link copied',
    saveSuccess: 'Saved successfully',
    changeSuccess: 'Successfully changed',
    sendSuccess: 'Successfully send',
    reject: 'Reject',
    accept: 'Accept',
  },
  vpValidation: {
    minQuestion: 'You must add at least %t% question',
  },
  videoPoll: {
    newAnswer: 'New video survey response',
    toMyVideoPolls: 'Back to My video surveys',
    createVideoPoll: 'Create video survey',
    generalInfo: 'General information',
    vacancy: 'Job vacancy',
    companyName: 'Company name',
    videoPollStartDelay: 'Initial delay of video survey',
    questionsCount: 'Number of questions',
    totalDuration: 'Total duration, min: sec',
    videoPollDatetime: 'Date and time of the video survey',
    favoritesText: 'Add to Favorites the most interesting recordings of the answers to the video survey from the applicants. You can always return to them and invite them for an interview.',
    addToTemplates: 'Add to video survey templates',
    welcomeMessage: 'Welcome message',
    welcomeMessageDescr: 'Welcome message displayed for applicants',
    questions: 'Questions',
    videoPollDescrTitle: 'Description of the video survey',
    hideVideoPollDescrTitle: 'Hide description',
    videoPollDescr: 'Describe in detail the purpose of the video survey, timing, etc.',
    videoPollDescr1: 'A detailed description of video survey',
    videoPollPlaceholder: 'Enter video survey description',
    videoPollMessage: 'Dear Applicant! The invitation consists of 1 question',
    videoPollTotalDuration: 'The total duration will be',
    questionsPopup: 'You can add up to 20 questions that potential Jobseekers must answer within the time period you specify.',
    questionsPopupAddToTemplate: 'You can add a question to the list of template questions',
    questionsPopupAddFromTemplate: 'You can add a question from the list of template questions',
    enterQuestionText: 'Enter your question text',
    addNewQuestion: 'add a new question',
    addQuestionDuration: 'Set the response time, <br> min:sec',
    addToQuestionTemplate: 'Add question to template questions',
    addFromQuestionTemplate: 'Add a question from template questions',
    addTemplateVideoPoll: 'Add a video survey template',
    addTemplateVideoPollText: 'You can add a ready-made video survey template, for example, for a specific position or profession with previously created questions',
    howItWork: 'How it works?',
    watchExample: 'See an example',
    save: 'Save',
    edit: 'Edit',
    greetDescr: 'The specified <strong>Welcome message</strong> is displayed on the start page of the potential Applicant before the start of the video survey',
    delayBetweenQuestions: 'Delay between questions, sec',
    videoPollDescription: 'Hello potential Job seekers!\n There is a vacancy for the position in our company\n The vacancy is urgent and we plan to close it no later than\n Please go through the video survey as quickly as possible and send the recording to our address.\n Yours faithfully, \n',
    videoPollMessage1: 'Dear Applicant!',
    videoPollMessage2: 'The video survey consists of',
    companyInvite: 'The invitation was sent from the %t% company',
    inviteText: 'You are invited to take a video survey for the vacancy',
    createVideoPollSuccess: 'Video survey created successfully',
    noVp: 'No video surveys',
    vpInviteTitle: 'Invite a registered job seeker for a video survey',
    editedLastTime: 'edited for the last time',
    receivedLastTime: 'received for the last time',
    sentLastTime: 'sent for the last time',
    created: 'created',
    receivedTime: 'received',
    sentedVp: 'Sent video surveys',
    forRegUsers: 'For registered users',
    forNotRegUsers: 'For unregistered and unauthorized users',
    sendVp: 'Send video survey',
    notAllowedTariff: 'Your current active tariff does not allow you to send created video questions for passing.',
    notAllowedTariffDescr: 'To get access to send created video questions, purchase the appropriate tariff.',
    removeVp: 'Delete video survey',
    receivedVp: 'Answers received from applicants',
    hideList: 'Collapse the list',
    showList: 'Show all',
    addToQuestionTemplateList: 'Question added to template questions',
    videoPollList: 'List of video surveys',
    backToMyVideoPolls: 'To my video surveys',
    createNewVp: 'Create a new video survey',
    confirmRemoveVideoPoll: 'Are you sure you want to delete a video poll?',
    vpLink: 'Link to video survey',
    shareByEmail: 'Send a link to a video survey by email',
    shareByEmailSuccess: 'Link sent successfully',
    sharedLink: 'Link to the video survey',
    addQuestionFromTemplates: 'Add a video survey from the list of template video surveys',
    questionListIsEmpty: 'The list of template video surveys is empty',
    createVp: 'Create video survey',
    vpList: 'List of video surveys and submitting for passing',
    sendAndReceived: 'Sent and Received video surveys',
    favoriteVP: 'Favorite video surveys',
    vpTemplates: 'Questions and video surveys templates',
    myVP: 'My video surveys',
    received: 'Received',
    noReceivedVp: 'No video surveys received',
    noSendVp: 'No video surveys sent',
    send: 'Sent',
    rating: 'Rating',
    anyRating: 'Any rating',
    sendInvition: 'Sent invitations to registered applicants',
    roleApplicant: 'Applicant',
    answerTime: 'Date and time of response',
    completedVideoSurveyLink: 'Link to completed video survey',
    noFavoriteVp: 'No favorite video surveys',
    videoSurveyTemplates: 'Video survey templates',
    tmplVsName: 'Enter a name for the video survey template',
    addNewTemplate: 'Add a new template',
    templateVsList: 'List of video survey templates',
    vsTmplEdit: 'Editing a video survey template',
    vsTmplEditText: 'Edit the name of the video survey template',
    vsTmplNamePlaceholder: 'Enter a name for the video survey template',
    vsTmplText: 'Enter a question in the video survey template or add from the list of template questions',
    vsTmplQuestionPlaceholder: 'Enter your question',
    questionTmpl: 'Question templates',
    enterQuestionPlaceholder: 'Enter your question',
    listOfQuestionTemplates: 'List of sample questions',
    addToVpTemplate: 'Add to video survey template',
    removeVsRecord: 'Are you sure you want to delete the video survey recording?',
    sendError: 'Failed to send video survey',
    sendEndDate: 'You can send a record of your answers no later than</br> %t%',
    vpDescr: 'Video survey description',
    recordedVp: 'Recorded video surveys',
    recordVpDescr: 'You can complete the video survey and <br /> send record',
    startVp: 'Complete the video survey',
    videoPollLink: 'Link to the completed video survey',
    vpIsLoading: 'video survey is being processed',
    recorded: 'recorded',
    sended: 'sent',
    receivedFrom: 'Received from:',
    notValidAccount: 'To pass the video survey, log in as a job seekers or',
    reg: 'register',
    candidateAccount: 'job seeker account',
    addFromTemplateList: 'Add question from question templates',
    tmplListIsEmpty: 'List of question templates is empty',
  },
  vpHelperCandidate: {
    one: 'Read the description of the video surveys. <br/> Select the company and vacancy that is most interesting to you',
    two: 'Take a video survey online in your spare time',
    three: 'Record unlimited video survey responses',
    four: 'Send the best recording of your video survey responses to the video survey author and wait for an invitation to a face-to-face interview.',
    five: 'Share the recording of the video survey, including with unregistered users',
  },
  vpHelperEmployer: {
    one: 'Before starting a video survey, create template questions or entire video survey templates that are most appropriate for your job or position.',
    two: 'Create a video survey for a specific job, enter the most revealing questions for the applicant, and set the response time, as well as the duration of the video survey. Use previously created template questions or entire video survey templates.',
    three: 'Send created video surveys to registered and unregistered users, send an invitation or a unique link by email.',
    four: 'Check the list of applicants to whom you have sent an invitation or a unique link. View the recordings of answers to your video surveys, choose the best candidates.',
    five: 'Add to Favorites the most interesting recordings of the answers to the video survey from the applicants. You can always return to them and invite them for an interview.',
  },
  filter: {
    hideFilter: 'Hide filter',
    openFilter: 'Customize filter',
    period: 'For the period',
    date: 'By date',
    companyName: 'By company name',
    vacancyName: 'By job title',
    vacancyNamePlaceholder: 'Enter the name of the vacancy',
    companyNamePlaceholder: 'Enter your company name',
    apply: 'Apply filter',
    reset: 'Reset filter',
    datePlaceholder: 'Select date',
    fromPeriod: 'For the period from',
    toPeriod: 'to',
    byName: 'Search by name',
  },
  helper: {
    showHide: 'show / hide helper',
    show: 'Show helper',
    hide: 'Hide helper',
  },
  vpRecord: {
    removeText: 'Do you really want abort passing video survey? <br/> The current record of video survey will be lost.',
    stopText: 'Abort passing video survey?',
    submitStopTex: 'Yes, I want to stop recording',
    vacancy: 'Video survey for the vacancy',
    company: 'To the company',
    nextQuestion: 'The next question will start in:',
    startText: 'The recording of the responses to the video survey will begin in\n',
    delayTextDescr: 'the time before the start of the recording was set by the initiator of the video survey',
    startRecording: 'Start recording a video survey',
    startRecordingAgain: 'Start over recording a video survey',
    startRecordingRemovePrev: 'Delete previous record',
    sendSuccess: 'Video survey successfully sent',
    user: 'User',
    sendTitle: 'Sending a video survey',
    recordSuccess: 'You have successfully recorded a video survey.',
    endOfHours: 'End of recording hours',
    endOfHoursText: 'Unfortunately, the author of the video surveys has run out of recording hours.',
    recordFormText: 'Fill in the fields for the possibility of sending a video survey to the initiator (all fields are required).',
    recordIsLoading: 'The video recording is being processed',
    saveText: 'Without waiting for the complete saving, you can assign a task to the system - sending the processed recording of the video survey to the initiator',
    saveNotFull: 'Since the recording for the entire video survey is not completely saved, you may not send it to the initiator of the video survey',
    saveAndLoading: 'Processing, saving and sending video survey',
    saveAndLoadingText: 'The video recording is being processed. After processing, it will be automatically saved on your page',
    recordSuccessRemoved: 'Record successfully deleted',

    addToFavorite: 'Add to favorite',
    removeFromFavorite: 'Remove from favorite',
    goToNextQuestion: 'Go to next question',
    minScreen: 'Minimize screen',
    stop: 'Stop playing',
    startPause: 'Start / continue playing the recording of the video survey',
    rate: 'Rate the job seeker\'s response',
  },
  vs: {
    pageList: 'Below is a list of all recorded and saved video sessions',
    descrAuth: 'To start chatting, just click on any screen below.<br/>Allow your browser to use the camera and microphone.<br/>Invite unregistered users to a video session, just send a unique link. <br/> Invite registered users to a video session, just send an invitation.',
    descrNotAuth: 'To start chatting, just click on any screen below.<br/>Allow your browser to use the camera and microphone.<br/> Invite up to two users to a video session, just send a unique link.',
    chat: 'Chat',
    chatTyping: 'typing',
    form: 'Note field',
    formClear: 'Clear field',
    chatPlaceholder: 'Please enter your message',
    pressVs: 'click to',
    startVs: 'start video session',
    inviteVs: 'send invitation',
    cancelInviteVs: 'Cancel invitation',
    sendInvite: 'The invitation is sent',
    recording: 'The recording is in progress',
    vs: 'Start video session',
    loadingText: 'Wait, the user is connecting <br/> to the video session',
    maxEmailCount: 'No more than %t% emails',
    sendLink: 'Link to the entrance to the cabinet for the video session',
    sendByEmail: 'Send link to video session by email',
    vsRecordAccess: 'To gain access to the recording of the video session, you must select and purchase the appropriate tariff',
    vsRecordAuth: 'Video session recording is available only for authorized users',
    myInstruction: 'My instructions',
    adminInstruction: 'Instructions',
    videoResume: 'video cv',
    videoVacancy: 'video vacancy',
    recordModalTitle: 'Video recording warning',
    recordModalText: 'Recording of the current video session starts',
    recordModalUser: 'User records video',
    vsEnd: 'Video session ended',
    creatorLeave: 'Video session creator disconnected',
    inviteToVs: 'Invite to video session',
    savingVs: 'Video processing and saving',
    endTariffHours: 'The end hours of recording in the tariff',
    vsSuccess: 'You have successfully completed a video session.',
    endHours: 'Unfortunately, the number of hours of recording in your tariff has completely ended.',
    vsVideoSaving: 'The video recording is being processed. After processing, it will be automatically saved on your page',
    vsBuyTariff: 'To be able to continue recording video sessions, purchase the appropriate tariff.',
    vsRecordStart: 'Start recording the current video session',
    vsRecordStartT: 'You start recording the current video session',
    vsRecordStartT2: 'After the end of the video session, the recording can be',
    vsReject: 'Rejecting video session recording',
    vsRecordReject: 'Video session rejected by users',
    vsWaiting: 'Waiting for confirmation of record',
    startRecVs: 'Start recording the current video session',
    startRecVsText: 'You start recording the current video session',
    startRecVsText1: 'After the end of the video session, the recording can be',
    saveTo: 'save to',
    notSaveTo: 'do not save to',
    sendToUsers: 'send the recording to the participants of the video session',
    noVideoRecords: 'No videos',
    removeText: 'Are you sure you want to delete the video record ?',
    sendText: 'Sending you a video record',
    vsLink: 'Link to video session',
  },
  vsHelper: {
    one: 'To start video session, <br/> just tap on any screen',
    two: ' Allow your browser <br/> to use the camera and microphone',
    three: 'Invite registered <br/> users to the video session, <br/> just send an invitation',
    four: 'Invite unregistered <br/> users to the video session, <br/> just send a unique link',
    five: 'Record a video session with users. <br/> The finished recording of the video session <br/> will be automatically saved in <strong>My video sessions</strong>',
  },
  vsBusinessHelper: {
    one: 'To start recording your video business card, <br/> click on any screen',
    two: ' Allow your browser <br/> to use the camera and microphone',
    three: 'Start an online video session. <br/> Get ready, in the field for notes, <br/> copy the outline of the text of your video business card',
    four: 'Start recording your video business card. <br/> Be bright, open and interesting to potential job seekers',
    five: 'The finished recording of your video business card <br/> will be automatically saved in My video business card',
  },
  vsVacancyHelper: {
    one: 'To record an independent video vacancy, <br/>  use the standard instructions <br/> for recording a video vacancy',
    two: 'Create your own version of the instruction <br/>  for recording a video vacancy',
    three: 'Watch video examples of recording video vacancies and video summaries, as well as video assistant - "How does it work?"',
    four: 'Expand the field with the instruction in full screen, this will allow you to have it before your eyes when recording a video vacancy',
    five: 'Use the note box while recording a video job. Copy the required text of the template directly into the note field, this will help you record a more effective video vacancy',
  },
  videoSessionTitle: {
    resume: 'Video CV recording',
    vacancy: 'Video vacancies recording',
    session: 'Start video session',
    businessCard: 'Video business cards recording',
  },
  videoRecordsTitle: {
    resume: 'My video CVs',
    vacancy: 'My video vacancies',
    session: 'My video sessions',
    businessCard: 'My video business card',
  },
  vsToolbar: {
    chat: 'Chat',
    endCall: 'End call',
    cameraOn: 'Camera on',
    cameraOff: 'Camera off',
    full: 'Expand video session to full screen',
    minimize: 'Reduce screen',
    microOn: 'Microphone on',
    microOff: 'Microphone off',
    pause: 'Pause',
    record: 'Record',
    stop: 'Stop',
    changeCamera: 'Switch camera',
    videoresumeInstruction: 'Video resume instruction',
    videovacancyInstruction: 'Video vacancy instruction',
  },
};
